<div class="CouponOverlay">
  <div class="CouponOverlay-Content">
    <pf-new-gift-card [isOverlay]="true" (closeOverlay)="closeOverlay.emit($event)"></pf-new-gift-card>
  </div>
</div>
